import { NavNyomtatvanyService } from './nav-nyomtatvany.service';
import { AnykKotes } from './anyk-kotes';
import { AnykSzabalymotor } from './anyk-szabalymotor';
import { lapArany } from './nyomtatas-keret';

/** Egy nyomtatandó lap a sablonon – az `app-anyk-lap` bemenetei. */
export interface NyomtatasLap {
  oldal: any; arany: number; hely: (fid: string) => any; mezo: (fid: string) => any; metak: any; matrixok: any;
}

/**
 *  A bevallások kitöltött lapjai, megnyitás nélkül (kötegelt nyomtatás, munkaterv-PDF).
 *  A lapkép ↔ adat leképezés ugyanaz (anyk-kotes.ts), mint a kitöltőben, tehát a papír ugyanaz,
 *  mintha egyenként nyomtatnánk. A `kotesTar` nyomtatványkódonként tartja a leképezést.
 *  Ahol nincs ÁNYK-lapkép, azt a `kihagy` kapja meg (a kitöltő nélkül nem nyomtatható).
 */
export async function nyomtatandoLapok(ny: NavNyomtatvanyService, sorok: { id: string; kod: string }[],
                                       kotesTar: Map<string, AnykKotes>, kihagy?: (b: { id: string; kod: string }) => void): Promise<NyomtatasLap[]> {
  const lapok: NyomtatasLap[] = [];
  for (const b of sorok) {
    const r: any = await ny.get('/bevallas/' + b.id);
    if (!r.vanEnyk) { kihagy?.(b); continue; }
    let k = kotesTar.get(b.kod);
    if (!k) {
      const enyk = await ny.get(`/sablon/${b.kod}/enyk`);
      let motor: AnykSzabalymotor | null = null;
      try { motor = new AnykSzabalymotor(enyk, r.modell); } catch { motor = null; }
      k = new AnykKotes(r.modell, enyk, motor);
      kotesTar.set(b.kod, k);
    }
    const kotes = k;
    for (const t of kotes.nyomtatandok(r.bevallas?.adat || {})) lapok.push({
      oldal: t.oldal,
      arany: lapArany(t.oldal),
      hely: (fid: string) => kotes.hely(t.formNev, t.peldany, t.oldal, t.din, fid),
      mezo: (fid: string) => kotes.mezo(t.formNev, fid),
      metak: kotes.enykForm(t.formNev)?.metak || {},
      matrixok: kotes.enyk?.matrixok || {},
    });
  }
  return lapok;
}
